import { defineHidden as B } from "@react-spring/shared";
var h = Symbol.for("Animated:node"),
  v = e => !!e && e[h] === e,
  k = e => e && e[h],
  D = (e, t) => B(e, h, t),
  F = e => e && e[h] && e[h].getPayload(),
  c = class {
    payload;
    constructor() {
      D(this, this);
    }
    getPayload() {
      return this.payload || [];
    }
  };
import { is as A } from "@react-spring/shared";
var l = class extends c {
  constructor(r) {
    super();
    this._value = r;
    A.num(this._value) && (this.lastPosition = this._value);
  }
  done = !0;
  elapsedTime;
  lastPosition;
  lastVelocity;
  v0;
  durationProgress = 0;
  static create(r) {
    return new l(r);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(r, n) {
    return A.num(r) && (this.lastPosition = r, n && (r = Math.round(r / n) * n, this.done && (this.lastPosition = r))), this._value === r ? !1 : (this._value = r, !0);
  }
  reset() {
    let {
      done: r
    } = this;
    this.done = !1, A.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, r && (this.lastVelocity = null), this.v0 = null);
  }
};
import { is as K, createInterpolator as R } from "@react-spring/shared";
var d = class extends l {
  _string = null;
  _toString;
  constructor(t) {
    super(0), this._toString = R({
      output: [t, t]
    });
  }
  static create(t) {
    return new d(t);
  }
  getValue() {
    let t = this._string;
    return t ?? (this._string = this._toString(this._value));
  }
  setValue(t) {
    if (K.str(t)) {
      if (t == this._string) return !1;
      this._string = t, this._value = 1;
    } else if (super.setValue(t)) this._string = null;else return !1;
    return !0;
  }
  reset(t) {
    t && (this._toString = R({
      output: [this.getValue(), t]
    })), this._value = 0, super.reset();
  }
};
import { isAnimatedString as q } from "@react-spring/shared";
import { each as L, eachProp as w, getFluidValue as M, hasFluidValue as C } from "@react-spring/shared";
var f = {
  dependencies: null
};
var u = class extends c {
  constructor(r) {
    super();
    this.source = r;
    this.setValue(r);
  }
  getValue(r) {
    let n = {};
    return w(this.source, (a, i) => {
      v(a) ? n[i] = a.getValue(r) : C(a) ? n[i] = M(a) : r || (n[i] = a);
    }), n;
  }
  setValue(r) {
    this.source = r, this.payload = this._makePayload(r);
  }
  reset() {
    this.payload && L(this.payload, r => r.reset());
  }
  _makePayload(r) {
    if (r) {
      let n = new Set();
      return w(r, this._addToPayload, n), Array.from(n);
    }
  }
  _addToPayload(r) {
    f.dependencies && C(r) && f.dependencies.add(r);
    let n = F(r);
    n && L(n, a => this.add(a));
  }
};
var y = class extends u {
  constructor(t) {
    super(t);
  }
  static create(t) {
    return new y(t);
  }
  getValue() {
    return this.source.map(t => t.getValue());
  }
  setValue(t) {
    let r = this.getPayload();
    return t.length == r.length ? r.map((n, a) => n.setValue(t[a])).some(Boolean) : (super.setValue(t.map(z)), !0);
  }
};
function z(e) {
  return (q(e) ? d : l).create(e);
}
import { is as G, isAnimatedString as J } from "@react-spring/shared";
function Le(e) {
  let t = k(e);
  return t ? t.constructor : G.arr(e) ? y : J(e) ? d : l;
}
import { is as g, eachProp as oe } from "@react-spring/shared";
import * as O from "react";
import { forwardRef as Q, useRef as H, useCallback as X, useEffect as Y } from "react";
import { is as N, each as V, raf as U, useForceUpdate as Z, useOnce as ee, addFluidObserver as te, removeFluidObserver as E, useIsomorphicLayoutEffect as re } from "@react-spring/shared";
var x = (e, t) => {
    let r = !N.fun(e) || e.prototype && e.prototype.isReactComponent;
    return Q((n, a) => {
      let i = H(null),
        o = r && X(s => {
          i.current = ae(a, s);
        }, [a]),
        [m, T] = ne(n, t),
        W = Z(),
        P = () => {
          let s = i.current;
          if (r && !s) return;
          (s ? t.applyAnimatedValues(s, m.getValue(!0)) : !1) === !1 && W();
        },
        _ = new b(P, T),
        p = H();
      re(() => (p.current = _, V(T, s => te(s, _)), () => {
        p.current && (V(p.current.deps, s => E(s, p.current)), U.cancel(p.current.update));
      })), Y(P, []), ee(() => () => {
        let s = p.current;
        V(s.deps, S => E(S, s));
      });
      let $ = t.getComponentProps(m.getValue());
      return O.createElement(e, {
        ...$,
        ref: o
      });
    });
  },
  b = class {
    constructor(t, r) {
      this.update = t;
      this.deps = r;
    }
    eventObserved(t) {
      t.type == "change" && U.write(this.update);
    }
  };
function ne(e, t) {
  let r = new Set();
  return f.dependencies = r, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new u(e), f.dependencies = null, [e, r];
}
function ae(e, t) {
  return e && (N.fun(e) ? e(t) : e.current = t), t;
}
var j = Symbol.for("AnimatedComponent"),
  Ke = function (e) {
    let {
      applyAnimatedValues: t = () => !1,
      createAnimatedStyle: r = a => new u(a),
      getComponentProps: n = a => a
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let a = {
        applyAnimatedValues: t,
        createAnimatedStyle: r,
        getComponentProps: n
      },
      i = o => {
        let m = I(o) || "Anonymous";
        return g.str(o) ? o = i[o] || (i[o] = x(o, a)) : o = o[j] || (o[j] = x(o, a)), o.displayName = `Animated(${m})`, o;
      };
    return oe(e, (o, m) => {
      g.arr(e) && (m = I(o)), i[m] = i(o);
    }), {
      animated: i
    };
  },
  I = e => g.str(e) ? e : e && g.str(e.displayName) ? e.displayName : g.fun(e) && e.name || null;
export { c as Animated, y as AnimatedArray, u as AnimatedObject, d as AnimatedString, l as AnimatedValue, Ke as createHost, k as getAnimated, Le as getAnimatedType, F as getPayload, v as isAnimated, D as setAnimated };